var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "data-user" } }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-12 mt-4" },
        [
          _c("ListUser", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              label: "Selecciona el usuario a eliminar",
              name: "targetUser",
              placeholder: "Usuario",
              danger: _vm.errors.has("data-user.targetUser"),
              "danger-text": _vm.errors.first("data-user.targetUser")
            },
            model: {
              value: _vm.userId,
              callback: function($$v) {
                _vm.userId = $$v
              },
              expression: "userId"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        !_vm.showConfirm && !_vm.confirm
          ? _c(
              "div",
              { staticStyle: { float: "right" } },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.attemptRemoveUser()
                      }
                    }
                  },
                  [_vm._v(" Remover ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.showConfirm
          ? _c("div", {}, [
              _c("p", { staticClass: "warning-confirmation" }, [
                _vm._v(" ¿Estás seguro de remover el usuario? ")
              ]),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-3",
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function($event) {
                          return _vm.discardChanges()
                        }
                      }
                    },
                    [_vm._v(" Mejor no ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.saveChanges()
                        }
                      }
                    },
                    [_vm._v(" Si, seguro ")]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }